/* istanbul ignore file */

import Vue from "vue";
import Vuex from "vuex";

import adminProductDetail from "./modules/adminProductDetail";
import brand from "./modules/brand";
import checkout from "./modules/checkout";
import checkoutPayment from "./modules/checkoutPayment";
import currentUser from "./modules/currentUser";
import eventShow from "./modules/eventShow";
import flashMessages from "./modules/flashMessages";
import global from "./modules/global";
import i18n from "./modules/i18n";
import lists from "./modules/lists";
import lunchMenu from "./modules/lunchMenu";
import lytics from "./modules/lytics";
import onboarding from "./modules/onboarding";
import otherVendors from "./modules/otherVendors";
import productSearch from "./modules/productSearch";
import parkingSpaces from "./modules/parkingSpaces";
import productShow from "./modules/productShow";
import shoppingCart from "./modules/shoppingCart";
import shoppingList from "./modules/shoppingList";
import userForm from "./modules/userForm";
import validations from "./modules/validations";
import variantPicker from "./modules/variantPicker";
import vendorShow from "./modules/vendorShow";
import vendorsIndex from "./modules/vendorsIndex";
import voucherEmployees from "./modules/voucherEmployees";

Vue.use(Vuex);

export default new Vuex.Store({
  modules: {
    adminProductDetail,
    brand,
    checkout,
    checkoutPayment,
    currentUser,
    eventShow,
    flashMessages,
    global,
    i18n,
    lists,
    lunchMenu,
    lytics,
    onboarding,
    otherVendors,
    productSearch,
    parkingSpaces,
    productShow,
    shoppingCart,
    shoppingList,
    userForm,
    validations,
    variantPicker,
    vendorShow,
    vendorsIndex,
    voucherEmployees,
  },
});
